import React from "react"

import styled from "styled-components"
import theme from "@irati/ui/src/global/theme"
import idHelper from "@irati/utils/id"
import authentication from "@irati/auth"
import {RouterLink} from "@irati/ui/src/Link"
import {WALLET} from "@irati-tracking/tracker/products"
import {FormattedMessage} from "@irati/utils/lang"
import {Body, H4} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import WalletBallance from "@irati/wallet/apollo/query/Wallet"
import {PaymentCurrencyType, WalletEntityType} from "@irati/types"

interface Props {
  id?: string
  onClick: () => void
}

const Wrapper = styled.div`
  border-top: 1px solid ${theme.colors.greys.light};

  > a {
    padding: ${theme.spacing.two};
  }

  ${theme.mediaQueries.maxWidthMedia.tablet`
    height: 130px;
  `}
`

const UserWallet: React.FC<Props> = (props) => {
  const {onClick} = props
  const showUserCurrencyWallet = authentication.apps("wallet.users")
  const showFlexiPoints = authentication.apps("wallet.treatTokens")
  const showFlexiRewards = authentication.apps("wallet.flexiRewards")
  const userId = authentication.user().uuid

  if (!showUserCurrencyWallet && !showFlexiPoints && !showFlexiRewards) {
    return null
  }

  return (
    <Wrapper>
      <RouterLink style={{display: "block"}} app={WALLET} id={idHelper("link-wallet", props)} onClick={onClick} to="/" plain>
        <Flex alignItems="center" justifyContent="space-between" marginBottom={2}>
          <Body small as="span">
            <FormattedMessage id="platform.wallet.menu.user.label" />
          </Body>
          <Icon icon={IconTypes.chevronRight} size={12} color={theme.colors.utility.ink} />
        </Flex>
        <Flex direction="column" gap={1.5}>
          {showFlexiPoints && (
            <Flex justifyContent="space-between" alignItems="center" flex="1">
              <Flex alignItems="center">
                <Icon icon={IconTypes.flexiPoints} size={18} marginRight={0.5} />
                <Body as="span" color={theme.colors.greys.black}>
                  <FormattedMessage id="platform.wallet.menu.user.flexiPoints" />
                </Body>
              </Flex>
              <WalletBallance useLoader={false} variables={{userId, entityType: WalletEntityType.User, currency: PaymentCurrencyType.Tt}}>
                {({data}) => {
                  if (!data || !data?.wallet) {
                    return <H4 as="span">-</H4>
                  }

                  return <H4 as="span">{data.wallet.availableBalance}</H4>
                }}
              </WalletBallance>
            </Flex>
          )}

          {showFlexiRewards && (
            <Flex justifyContent="space-between" alignItems="center" flex="1">
              <Flex alignItems="center">
                <Icon icon={IconTypes.rewardPoints} size={18} marginRight={0.5} />
                <Body as="span" color={theme.colors.greys.black}>
                  <FormattedMessage id="platform.wallet.menu.rewardPoints" />
                </Body>
              </Flex>
              <WalletBallance useLoader={false} variables={{userId, entityType: WalletEntityType.User, currency: PaymentCurrencyType.Rp}}>
                {({data}) => {
                  if (!data || !data?.wallet) {
                    return <H4 as="span">-</H4>
                  }

                  return <H4 as="span">{data.wallet.availableBalance}</H4>
                }}
              </WalletBallance>
            </Flex>
          )}
        </Flex>
      </RouterLink>
    </Wrapper>
  )
}

export default UserWallet
